<template>
  <div>
    <v-btn text @click.stop="startForm('login')">Login</v-btn>
    <v-btn text @click.stop="startForm('register')">Register</v-btn>
    <v-btn text @click.stop="logout">Logout</v-btn>

    <v-navigation-drawer
      dark
      color="blue-grey darken-4"
      v-model="drawer"
      app
      absolute
      right
      temporary
    >
      <LoginForm :type="type" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import LoginForm from "./LoginForm";
import firebase from "firebase";
export default {
  data: () => ({
    drawer: false,
    type: ""
  }),
  components: { LoginForm },
  methods: {
    startForm: function(text) {
      this.type = text;
      this.drawer = !this.drawer;
    },
    logout: function() {
      firebase.auth().signOut();
    }
  }
};
</script>

<style></style>
